export const appExpandMenuIcon = {
    data: `<svg viewBox="0 0 29 29" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M4 7H19" stroke="black" stroke-width="2" stroke-linecap="round"/><path d="M4 12H19" stroke="black" stroke-width="2" stroke-linecap="round"/><path d="M4 17H11" stroke="black" stroke-width="2" stroke-linecap="round"/></svg>`,
    name: 'expand-menu'
};